<div class="modal-border">
  <ion-header>
    <ion-toolbar></ion-toolbar>
  </ion-header>

  <ion-content style="height: 800px">
    <ion-datetime
      [(value)]="date"
      (ionChange)="onPickerChange($event)"
      presentation="date"
    ></ion-datetime>

    <ion-grid>
      <ion-row>
        <ion-col size="3">
          <ion-label class="link-look-n-feel">Year</ion-label>
        </ion-col>
        <ion-col size="1"> </ion-col>
        <ion-col size="3">
          <ion-label class="link-look-n-feel">Month</ion-label>
        </ion-col>
        <ion-col size="1"> </ion-col>
        <ion-col size="3">
          <ion-label class="link-look-n-feel">Day</ion-label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="3">
          <ion-item>
            <ion-input [(ngModel)]="year" (change)="onDateChange()"></ion-input>
          </ion-item>
        </ion-col>
        <ion-col size="1">
          <ion-label style="font-size: xx-large">\</ion-label>
        </ion-col>
        <ion-col size="3">
          <ion-item>
            <ion-input
              [(ngModel)]="month"
              (change)="onDateChange()"
            ></ion-input>
          </ion-item>
        </ion-col>
        <ion-col size="1">
          <ion-label style="font-size: xx-large">\</ion-label>
        </ion-col>
        <ion-col size="3">
          <ion-item>
            <ion-input [(ngModel)]="day" (change)="onDateChange()"></ion-input>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-button
      class="modal-ion-col-bottom-buttons"
      (click)="onCloseUpload()"
      style="width: 90% !important; left: 0"
    >
      <ion-icon name="checkmark-circle-outline"></ion-icon>Close
    </ion-button>
  </ion-content>
</div>
